import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  Tooltip,
  MenuItem,
  Select,
  AppBar,
  Toolbar,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import { useNavigate } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const EditFormRegister = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [moduleName, setModuleName] = useState('admission');
  const [formName, setFormName] = useState('Admission Form');
  const [formUrl, setFormUrl] = useState('/admission');
  const [formSequence, setFormSequence] = useState('1');
  const [formDescription, setFormDescription] = useState('Form for new student admissions');
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('https://via.placeholder.com/150');
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);

  const navigate = useNavigate();

  // Static list of modules for the dropdown
  const moduleOptions = [
    { value: 'admission', label: 'Admission' },
    { value: 'exam', label: 'Exam' },
    { value: 'feedback', label: 'Feedback' },
    { value: 'leave', label: 'Leave' },
    { value: 'event', label: 'Event' },
  ];

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadImage = () => {
    if (!selectedImage) {
      alert('Please select an image first!');
      return;
    }
    // Simulate image upload
    setLoadingBarProgress(30);
    setTimeout(() => {
      setLoadingBarProgress(100);
      alert('Image uploaded successfully!');
    }, 1000);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    // Simulate API call
    setLoadingBarProgress(30);
    setTimeout(() => {
      setLoadingBarProgress(100);
      setShowSuccessModal(true);
    }, 1000);
  };

  const handleCancel = () => {
   navigate(-1)
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit Form Register
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="moduleName">Module Name</InputLabel>
            <Select
              id="moduleName"
              value={moduleName}
              label="Module Name"
              onChange={(e) => setModuleName(e.target.value)}
            >
              {moduleOptions.map((module) => (
                <MenuItem key={module.value} value={module.value}>
                  {module.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Form Name"
            variant="outlined"
            fullWidth
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Form URL"
            variant="outlined"
            fullWidth
            value={formUrl}
            onChange={(e) => setFormUrl(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Form Sequence"
            variant="outlined"
            fullWidth
            type="number"
            value={formSequence}
            onChange={(e) => setFormSequence(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>Upload Image</Typography>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: 'none' }}
              id="image-upload"
            />
            <label htmlFor="image-upload">
              <Button
                variant="contained"
                component="span"
                startIcon={<CloudUploadIcon />}
                sx={{ mr: 2, mb: 2 }}
              >
                Choose Image
              </Button>
            </label>
            {imagePreview && (
              <Box sx={{ mt: 2, textAlign: 'center' }}>
                <img
                  src={imagePreview}
                  alt="Preview"
                  style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 4 }}
                />
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleUploadImage}
                  sx={{ mt: 1 }}
                >
                  Upload Image
                </Button>
              </Box>
            )}
          </Box>
          <TextField
            label="Form Description"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={formDescription}
            onChange={(e) => setFormDescription(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip
            title={
              !moduleName
                ? "Select Module Name"
                : !formName
                ? "Enter Form Name"
                : !formUrl
                ? "Enter Form URL"
                : !formSequence
                ? "Enter Form Sequence"
                : !formDescription
                ? "Enter Form Description"
                : ""
            }
            arrow
          >
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
                sx={{ mr: 2 }}
                disabled={!moduleName || !formName || !formUrl || !formSequence || !formDescription}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Form Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Form Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditFormRegister;
